import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { CommonService } from 'src/app/core/services/common.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { SignatureConfigService } from "src/app/core/services/signature-config.service";
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { TemplateFormService } from 'src/app/core/services/template-form.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { DialogPreviewPdfComponent } from '../../../document-management/dialog-preview-pdf/dialog-preview-pdf.component';
import { SelectDocumentTypeComponent } from '../../select-document-type/select-document-type.component';
import { FormTemplateMohaComponent } from './form-template-moha/form-template-moha.component';



@Component({
  selector: 'app-document-form-moha',
  templateUrl: './document-form-moha.component.html',
  styleUrls: ['./document-form-moha.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DocumentFormMohaComponent extends BaseComponent implements OnInit, OnDestroy {
  @BlockUI() blockUI: NgBlockUI;

  @ViewChild('formTemplate', { static: true })
  public formTemplate: FormTemplateMohaComponent;

  public templateId: number;
  private isExport: boolean = false;

  private subcription: Subscription = new Subscription();
  private isUpdate: boolean = false;
  public documentTemplateFile: TemplateFile = null;
  public name: string;
  public url: string;
  public selectedIndex: number = 0;
  public showWarning: boolean = false;

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private createContractMohaService: CreateContractMohaService,
    private documentTemplateService: DocumentTemplateService,
    private templateFileService: TemplateFileService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public changeDetector: ChangeDetectorRef,
    public signatureConfigService: SignatureConfigService,
    public documentTypeService: DocumentTypeService,
    public templateFormService: TemplateFormService,
    private cdr: ChangeDetectorRef,
  ) {
    super(commonService, message);
    this.notifier = notifier;

    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.typeUpdate) {
        this.isUpdate = true;
      }
    })

    const exportDataSub = this.createContractMohaService.isExportData.subscribe(isExport => {
      if (isExport && !this.isExport) {
        this.isExport = true;
        // if (!this.createContractMohaService.isValidForm.getValue() && this.selectedIndex === 1) {
        //   this.selectedIndex = 0;
        //   return;
        // }
        // if (this.selectedIndex === 0) {
        this.formTemplate.exportDataField();
        // } else {
        //   this.mergeFieldToFile();
        // }
      }
      if (!isExport) {
        this.isExport = false;
      }
    });
    this.subcription.add(exportDataSub);
    const saveDataSub = this.createContractMohaService.saveDataTable.subscribe(save => {
      if (save) {
        this.formTemplate.saveDataTable(true);
      }
    })
    this.subcription.add(saveDataSub);
    // Dung để check xem có fill giá trị từ step 2 vào step 3 hay ko?
    this.createContractMohaService.prevStep.next(1)
  }

  ngOnInit() {
    this.createContractMohaService.selectedTemplate.asObservable().subscribe(template => {
      if (this.createContractMohaService.currentStep.getValue() !== 1) {
        return;
      }
      const userSign = this.createContractMohaService.recordsPartySign.getValue();
      const tableModel = this.createContractMohaService.tableModel;
      const signatureData = this.createContractMohaService.signatureData.getValue();
      if (tableModel) {
        if (this.createContractMohaService.isCopy) {
          this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : [], true);
          this.createContractMohaService.isCopy = false;
        } else {
          this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : []);
        }
        // this.signature.showSignatureFromData(signatureData ? signatureData : [], userSign && userSign.length ? userSign : []);
        if (template && template.id) {
          this.getTemplateFile(template.id);
        }
        const document = this.createContractMohaService.document.getValue();
        if (document && document.templateFilePath) {
          this.url = document.templateFilePath;
        }
        return;
      }
      if (template && template.id) {
        this.formTemplate.generateForm(template.id, userSign && userSign.length ? userSign : []);
        // this.signature.genSignature(template.id, userSign && userSign.length ? userSign : []);
        this.getTemplateFile(template.id);
      }
    });
    this.createContractMohaService.document.subscribe((ref: any) => {
      if (ref && ref.editedLotContract === false) {
        this.showWarning = true;
      }
    })
  }

  ngOnDestroy(): void {
    this.subcription.unsubscribe();
  }

  getTemplateFile(id: string) {
    this.documentTemplateService.getDocumentTemplateById(id).subscribe(response => {
      if (!response || !response.data) {
        if (this.isUpdate) {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
          }
        } else {
          this.documentInactiveHandler();
        }
        return;
      }
      this.createContractMohaService.documentTemplate = response.data;
      this.name = response.data.name ? response.data.name : '';
      this.templateFileService.getTemplateFile(response.data.documentTemplateId).subscribe(res => {
        if (!res || !res.data || !res.data.length) {
          return;
        }
        this.createContractMohaService.documentFileTemplate.next(res.data[0]);
        this.documentTemplateFile = res.data[0];
      });
    })
  }

  private documentInactiveHandler() {
    if (!this.toastr.findDuplicate(this.message.getMessage("messages.confirm_use_inactive_template"), true, true)) {
      this.toastr.error(this.message.getMessage("messages.confirm_use_inactive_template"));
      const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
        width: '30%',
        disableClose: true,
        data: { mode: null }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (typeof result !== 'undefined') {
          this.createContractMohaService.selectedTemplate.next(result.data.documentTypeEnterprise);
        }
      });
    }
  }

  // public changeTab(event: any) {
  //   this.selectedIndex = event.index;
  //   if (event.index === 0) {
  //     this.formTemplate.rerender(() => {
  //       const userSign = this.createContractMohaService.recordsPartySign.getValue();
  //       const tableModel = this.createContractMohaService.tableModel;
  //       if (tableModel) {
  //         this.formTemplate.processDataWithModel(tableModel, userSign && userSign.length ? userSign : [], this.createContractMohaService.isExportData.getValue());
  //         if (this.createContractMohaService.isExportData.getValue()) {
  //           this.createContractMohaService.isExportData.next(false);
  //         }
  //         return;
  //       }
  //     });
  //   } else {
  //     this.formTemplate.saveDataTable();
  //   }
  // }

  preview(event: any) {
    event.stopPropagation();
    if (this.url) {
      this.templateFileService.convertDocxToPdf({ url: this.url }).subscribe(rs => {
        if (!rs) {
          return;
        }
        this.dialog.open(DialogPreviewPdfComponent, {
          width: '80%',
          data: {
            file: rs,
            name: this.name,
          },
        });
      })
    } else if (this.documentTemplateFile) {
      this.templateFileService.getContentTemplateFileByUrl({
        type: 'TEMPLATE_PDF',
        url: this.documentTemplateFile.file.pdfUrl
      }).subscribe(rs => {
        if (!rs) {
          return;
        }
        this.dialog.open(DialogPreviewPdfComponent, {
          width: '80%',
          data: {
            file: rs,
            name: this.name,
          },
        });
      })
    }

  }

  // mergeFieldToFile() {
  //   this.blockUI.start('');
  //   this.cdr.detectChanges();
  //   const fields = this.createContractMohaService.fieldData;

  //   let url = this.documentTemplateFile && this.documentTemplateFile.file && this.documentTemplateFile.file.url;
  //   const document = this.createContractMohaService.document.getValue() as any;
  //   if (document && document.templateFilePath) {
  //     url = document.templateFilePath
  //   }
  //   if (!url) {
  //     this.createContractMohaService.isExportData.next(false);
  //     this.blockUI.stop();
  //     this.cdr.detectChanges();
  //     return;
  //   }
  //   this.templateFormService.mergeDataToFile({ list: fields, url: url }).subscribe(res => {
  //     // if (res && res.type === 'application/json') {
  //     //     this.createContractMohaService.isExportData.next(false);
  //     //     this.proccessSuccess.next(false);
  //     //     return;
  //     // }
  //     this.commonService.readFile(res, (pdfSrc) => {
  //       this.createContractMohaService.pdfSrc.next(pdfSrc);
  //     });
  //     this.createContractMohaService.changeFileOutput = false;
  //     this.createContractMohaService.fileExport = res;
  //     this.createContractMohaService.isExportData.next(false);
  //     this.createContractMohaService.isSuccessStep2.next(true);
  //     this.blockUI.stop();
  //     this.cdr.detectChanges();
  //   });
  // }
}
